import { Module } from 'vuex'

import { BrandSkuState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: BrandSkuState = {
  brandSkus: [],
  isBrandSkusLoading: false,
}

export const brandSku: Module<BrandSkuState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
